export const getArrayWithUniquiElems = (array: any[]) =>
  array.filter((elem, index) => {
    return array.indexOf(elem) === index;
  });
